import React, { useCallback } from "react";
import DialogContent from "@mui/material/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useTheme, DialogActions } from "@mui/material";
import { DialogModalStyles, EventModalTypes } from "../DialogModalWrapper";
import { IFlight, IGroundEvent } from "@vmosolutions/oc-interfaces";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import _ from "lodash";
import { isFlight } from "src/redux/reducers/FlightTimelineReducer";
import { updateSelectedFlight, updateSelectedGroundEvent } from "src/redux/actions/flights/FlightData.Actions";
import { setSelectedEvents } from "src/redux/actions/flights/FlightTimeline.Actions";
import { ModalTitle, ModalMessage, ModalButton } from "../DialogModalComponents";

interface IUnassignFlightModalProps {
  isOpen: boolean;
  handleClose: (value: boolean) => void;
  setActiveEventModal: (EventModalTypes: EventModalTypes) => void;
}

export const performUnassign = (selectedFlights: IFlight[], selectedGroundEvents: IGroundEvent[], dispatch: any) => {
  if (selectedFlights.length > 0) {
    const update: any = {
      aircraft: null,
    };
    selectedFlights.forEach((selectedFlight: IFlight) => {
      dispatch(updateSelectedFlight(selectedFlight._id, update));
    });
  } else {
    selectedGroundEvents.forEach((selectedGroundEvent: IGroundEvent) => {
      const unassignedGroundEvent = _.cloneDeep(selectedGroundEvent);
      unassignedGroundEvent.aircraft = null;
      dispatch(updateSelectedGroundEvent(unassignedGroundEvent._id, unassignedGroundEvent));
    });
  }
  dispatch(setSelectedEvents([]));
};

export const UnassignFlightModal = (props: IUnassignFlightModalProps): JSX.Element => {
  const { isOpen, handleClose, setActiveEventModal } = props;
  const dispatch = useDispatch();
  const theme = useTheme();
  const selectedEvents: (IFlight | IGroundEvent)[] = useSelector(
    (state: IRootState) => state.timelineFlights.selectedEvents
  );
  const selectedGroundEvents: IGroundEvent[] = React.useMemo(() => {
    return selectedEvents.filter((event: IFlight | IGroundEvent) => !isFlight(event)) as IGroundEvent[];
  }, [selectedEvents]);

  const selectedFlights: IFlight[] = React.useMemo(() => {
    return selectedEvents.filter((event: IFlight | IGroundEvent) => isFlight(event));
  }, [selectedEvents]);

  const handleCancel = useCallback((): void => {
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
  }, [handleClose, setActiveEventModal]);

  const handleConfirm = useCallback((): void => {
    performUnassign(selectedFlights, selectedGroundEvents, dispatch);
    //I don't like that you don't know if the unassign was successful or not...
    dispatch(setSelectedEvents([]));
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
  }, [dispatch, handleClose, selectedFlights, selectedGroundEvents, setActiveEventModal]);

  if (isOpen) {
    return (
      <DialogContent sx={DialogModalStyles(theme)}>
        <div className="modal_content">
          <ModalTitle title="Unassign Flight"></ModalTitle>
          <ModalMessage message={"Are you sure you would like to unassign this flight?"}></ModalMessage>
          <DialogActions>
            <ModalButton label={"Cancel"} handler={handleCancel}></ModalButton>
            <ModalButton label={"Confirm"} handler={handleConfirm}></ModalButton>
          </DialogActions>
        </div>
      </DialogContent>
    );
  } else {
    return <></>;
  }
};
